const APP_RELEASE_KEY = "gm_app_release";

async function unregisterStaleServiceWorkers() {
  if (!("serviceWorker" in navigator)) return;

  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(
    registrations.map((registration) => registration.unregister()),
  );
}

export async function checkForAppUpdate() {
  await unregisterStaleServiceWorkers();

  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: "no-store",
    });

    if (!response.ok) return;

    const { version, buildTime } = await response.json();
    const releaseId = `${version}@${buildTime}`;
    const storedRelease = localStorage.getItem(APP_RELEASE_KEY);

    if (storedRelease && storedRelease !== releaseId) {
      localStorage.setItem(APP_RELEASE_KEY, releaseId);
      window.location.reload();
      await new Promise(() => {});
    }

    if (!storedRelease) {
      localStorage.setItem(APP_RELEASE_KEY, releaseId);
    }
  } catch {
    // Skip when version.json is unavailable (e.g. offline).
  }
}
